import { useState, useEffect } from 'react'

export function useCountdown(initialHours: number = 24) {
  const [timeLeft, setTimeLeft] = useState({
    hours: initialHours,
    minutes: 0,
    seconds: 0,
  })

  useEffect(() => {
    // Check if we have a saved end time in localStorage
    const savedEndTime = localStorage.getItem('quimica_countdown_end')
    let endTime: number

    if (savedEndTime) {
      endTime = parseInt(savedEndTime, 10)
      // If the saved time is in the past, reset it
      if (endTime < Date.now()) {
        endTime = Date.now() + initialHours * 60 * 60 * 1000
        localStorage.setItem('quimica_countdown_end', endTime.toString())
      }
    } else {
      endTime = Date.now() + initialHours * 60 * 60 * 1000
      localStorage.setItem('quimica_countdown_end', endTime.toString())
    }

    const calculateTimeLeft = () => {
      const difference = endTime - Date.now()

      if (difference > 0) {
        setTimeLeft({
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60),
        })
      } else {
        setTimeLeft({ hours: 0, minutes: 0, seconds: 0 })
      }
    }

    calculateTimeLeft()
    const timer = setInterval(calculateTimeLeft, 1000)

    return () => clearInterval(timer)
  }, [initialHours])

  return timeLeft
}
